import React from "react";

export const PolicyContext = React.createContext();
export const GeneralContext = React.createContext(); // loading, language, user, logged...
export const CoveragesContext = React.createContext();
export const DynamicProductsContext = React.createContext();
export const PayTypesContext = React.createContext();